<template>
  <div class="advert-group-rela">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('adverts.AdvertGroupRela.067262-0')"
      :visible.sync="dialogAdvertGroupRela"
      width="850px"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form :label-position="labelPosition" ref="advertGroupRela" label-width="90px" :model="filterValue">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('advertGroupRela.isAdd')" prop="value" v-if="!isBatch">
                <el-select
                  v-model="filterValue.value"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('common.select')"
                  @change="advertChange"
                  style="margin-bottom: 20px"
                >
                  <el-option :label="$t('advertGroupRela.yes')" value="1"></el-option>
                  <el-option :label="$t('advertGroupRela.no')" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('advertGroupRela.showType')" prop="display">
                <el-select
                  v-model="filterValue.display"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('advertGroupRela.filterShowType')"
                  @change="showTypeChange"
                  style="margin-bottom: 20px"
                >
                  <el-option
                    v-for="item in showType"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-table
          ref="advertTable"
          v-loading="loading"
          :empty-text="$t('common.noData')"
          :element-loading-text="$t('common.loading')"
          :data="advertList"
          height="450px"
          :row-key="'id'"
          @selection-change="selectChange"
          style="width: 100%"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            width="130"
            :formatter="formatterShowType"
            :label="$t('advertGroupRela.showType')"
          ></el-table-column>
          <el-table-column :label="$t('adverts.showContent')" width="150">
            <template slot-scope="scope">
              <template v-if="scope.row.type == 0">
                <el-tooltip class="item" effect="dark" :content="$t('advertGroupRela.big')" placement="top-start">
                  <el-image
                    style="height: 102px"
                    :preview-src-list="imageList"
                    :src="scope.row.url"
                    fit="cover"
                  ></el-image>
                </el-tooltip>
              </template>
              <template v-else>
                <video
                  :src="scope.row.url"
                  :controls="true"
                  style="width: 120px !important; height: 100px !important"
                ></video>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="head" :label="$t('advertGroupRela.title')"></el-table-column>
          <el-table-column prop="startTime" :label="$t('advertGroupRela.startTime')" width="180"></el-table-column>
          <el-table-column prop="endTime" :label="$t('advertGroupRela.endDate')" width="180"></el-table-column>
        </el-table>

        <el-pagination
          style="margin-top: 20px; text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button
          type="primary"
          v-if="filterValue.value === '0'"
          :disabled="selectList.length <= 0 && loadingForm"
          @click="batchAddAdvert(0)"
          >{{ $t("advertGroupRela.add") }}</el-button
        >
        <el-button
          type="danger"
          v-if="filterValue.value === '1'"
          :disabled="selectList.length <= 0 && loadingForm"
          @click="batchDelAdvert(1)"
          >{{ $t("advertGroupRela.remove") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "AdvertGroupRela",
    props: {
      dialogAdvertGroupRela: Boolean,
      advertGroup: Object,
      showType: Array,
      type: {
        default: 1, // 1管理员进入 2用户进入
        type: Number
      },
      isBatch: {
        default: false,
        type: Boolean
      }
    },
    data() {
      return {
        advertList: [],
        advertListBack: [],
        loading: false,
        selectList: [],
        imageList: [],
        filterValue: {
          title: "",
          value: "1",
          display: "1"
        },
        labelPosition: "top",
        loadingForm: false,
        currentPage: 1,
        pageSize: 10,
        total: 0
      };
    },
    methods: {
      cancel() {
        this.$emit("cancelAdvertGroupRela", false);
      },
      closeDialog() {
        this.filterValue.value = "1";
        this.filterValue.display = "1";
        this.currentPage = 1;
        this.pageSize = 10;
        this.advertList = [];
        this.total = 0;
        this.selectList = [];
        this.imageList = [];
        this.cancel();
      },
      openDialog() {
        if (this.isBatch) {
          this.filterValue.value = "0";
        }
        this.advertChange();
      },
      advertChange() {
        this.loading = true;
        this.selectList = [];
        let obj = {
          type: this.isBatch ? null : this.filterValue.value,
          display: this.filterValue.display,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };

        if (this.type == 2) {
          obj.equipmentId = this.advertGroup.id;
        } else {
          obj.labelTeamId = this.advertGroup.id;
        }

        this.$api
          .request(this.$url.AdvertGroup.select, this.$method.get, obj)
          .then(res => {
            if (res.code === 0 && res.data && Array.isArray(res.data.records)) {
              this.advertList = res.data.records;
              this.total = parseInt(res.data.total) || 0;
              this.showImage(this.advertList);
            } else {
              this.advertList = [];
              this.total = 0;
              this.imageList = [];
              this.$message.error(res.msg || this.$t("common.requestFailed"));
            }
            this.loading = false;
          })
          .catch(() => {
            this.$message.error(this.$t("adverts.AdvertGroupRela.067262-1"));
            this.advertList = [];
            this.total = 0;
            this.imageList = [];
            this.loading = false;
          });
      },
      showTypeChange() {
        this.currentPage = 1;
        this.advertChange();
      },
      showImage(data) {
        this.imageList = [];
        if (Array.isArray(data)) {
          data.forEach(k => {
            if (k.type == 0 && k.url) {
              this.imageList.push(k.url);
            }
          });
        }
      },
      formatterShowType(row) {
        if (Array.isArray(this.showType)) {
          return this.$cloud.getDictLabel(this.showType, row.display);
        }
        return row.display;
      },
      selectChange(val) {
        this.selectList = val;
      },
      handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.currentPage = 1;
        this.advertChange();
      },
      handleCurrentChange(newPage) {
        this.currentPage = newPage;
        this.advertChange();
      },
      batchAddAdvert(val) {
        this.updateAdvertConfig(val);
      },
      batchDelAdvert(val) {
        this.updateAdvertConfig(val);
      },
      updateAdvertConfig(val) {
        if (this.selectList.length < 1) {
          this.$notify({
            title: this.$t("common.tip"),
            message: this.$t("advertGroupRela.isNaN"),
            type: "warning"
          });
          return;
        }
        const selectedIds = this.selectList.map(item => item.id);
        const firstSelectedUId = this.selectList.length > 0 ? this.selectList[0].uId : null;

        if (selectedIds.length === 0 || !firstSelectedUId) {
          this.$notify({
            title: this.$t("common.tip"),
            message: this.$t("advertGroupRela.selectAdError"),
            type: "error"
          });
          return;
        }

        this.$confirm(
          this.$t("common.definite") +
            (val === 0 ? this.$t("advertGroupRela.add") : this.$t("advertGroupRela.remove")) +
            this.$t("advertGroupRela.selectAd") +
            ` (${this.selectList.length} 项)?`,
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            this.loadingForm = true;
            let obj = {
              type: val === 1 ? 0 : 1,
              id: this.advertGroup.id,
              ids: selectedIds,
              uId: firstSelectedUId,
              display: this.filterValue.display
            };
            let url = "";
            let methods = null;
            if (this.isBatch) {
              url = this.$url.UserMachine.setAdvertTeam;
              methods = this.$method.put;
            } else if (this.type == 2) {
              url = this.$url.AdvertGroup.updateAdConfigUser;
              methods = this.$method.post;
            } else {
              url = this.$url.AdvertGroup.updateAdvertConfig;
              methods = this.$method.post;
            }
            this.$api
              .request(url, methods, obj)
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg || this.$t("common.operateSuccess"),
                    type: "success"
                  });
                  this.selectList = [];
                  this.$nextTick(() => {
                    if (this.$refs.advertTable) {
                      this.$refs.advertTable.clearSelection();
                    }
                  });
                  if (this.isBatch) {
                    this.$emit("cancelAdvertGroupRela");
                  } else {
                    this.advertChange();
                  }
                } else {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg || this.$t("common.operateFailed"),
                    type: "error"
                  });
                }
                this.loadingForm = false;
              })
              .catch(err => {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: err.msg || this.$t("common.operateError"),
                  type: "error"
                });
                this.loadingForm = false;
              });
          })
          .catch(() => {});
      }
    }
  };
</script>

<style scoped></style>
